import { render, staticRenderFns } from "./PageRouteView.vue?vue&type=template&id=576acf44&scoped=true&"
import script from "./PageRouteView.vue?vue&type=script&lang=js&"
export * from "./PageRouteView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576acf44",
  null
  
)

export default component.exports